import { createAction, props } from '@ngrx/store';
import { CountryInfo } from '@sharedModule/models/country.model';

export const loadDestinationCountry = createAction(
  '[Destination Country] Load Destination Country',
  props<{ payload: { partner_id?: number; src_country: string } }>()
);

export const loadDestinationCountrySuccess = createAction(
  '[Destination Country] Load Destination Country Success',
  props<{ destinationCountries: CountryInfo[]; sourceCurrency: CountryInfo }>()
);

export const loadDestinationCountryFailure = createAction(
  '[Destination Country] Load Destination Country Failure',
  props<{ error: string }>()
);

export const deleteDestCountry = createAction(
  '[Destination Country] Delete Destination Country',
  props<{
    srcCountryName: string;
    destCountryName: string;
  }>()
);
